import { render, staticRenderFns } from "./MarzipanoBubbleHotspot.vue?vue&type=template&id=a34e284a&scoped=true"
import script from "./MarzipanoBubbleHotspot.vue?vue&type=script&lang=js"
export * from "./MarzipanoBubbleHotspot.vue?vue&type=script&lang=js"
import style0 from "./MarzipanoBubbleHotspot.vue?vue&type=style&index=0&id=a34e284a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a34e284a",
  null
  
)

export default component.exports